import React from "react";

export function PageHeader({ overline, title, subtitle, actions }) {
  return (
    <div className="flex items-start justify-between mb-6 gap-4 flex-wrap">
      <div>
        {overline && <div className="overline mb-1">{overline}</div>}
        <h1 className="font-display text-3xl font-extrabold tracking-tight">{title}</h1>
        {subtitle && <p className="text-slate-500 text-sm mt-1.5 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, hint, action }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center border border-dashed border-slate-300 rounded-md bg-white">
      {Icon && <Icon className="text-slate-300 mb-3" size={36} />}
      <div className="font-semibold text-slate-700">{title}</div>
      {hint && <div className="text-sm text-slate-400 mt-1 max-w-md">{hint}</div>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
